import { PrimaryLink } from "../ui/Buttons";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import A from "../../assets/align.png";

const TireServicesAlignment = () => {
  return (
    <>
      <SeoHead
        title="Tire Service & Wheel Alignment in Temecula | Advanced Automotive Smog"
        description="Tire service and wheel alignment in Temecula, including balancing and alignment checks, for a smoother ride and more even tire wear."
        path="/services/tire-alignment"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Tire Services & Alignment"
          path="/services/tire-alignment"
          description="Tire service and wheel alignment in Temecula, including balancing and alignment checks."
          serviceType="Tire service and wheel alignment"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={A}
                alt="Tire Services & Alignment"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Tire Safety
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Tire Services & Alignment
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Ensure a smooth, safe, and fuel-efficient ride with our expert tire
              services and precise wheel alignment. We handle everything from
              repairs to replacements to balancing.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is Tire Service & Alignment?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Over time, wheels can drift out of alignment, causing uneven tire
              wear, vibration, poor handling, and reduced fuel efficiency. Our
              technicians inspect, balance, and align your wheels to restore smooth,
              safe driving and extend tire lifespan.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Fast and reliable tire repair & replacement
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Expert wheel alignment and balancing
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                High-quality tires from trusted brands
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Compatible with all makes and models
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Tips for maintaining tire longevity and safety
              </li>
            </ul>

            {/* Button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>

        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default TireServicesAlignment;





